<div class="c-404">
  <div class="row">
    <div class="col-12">
      <img :src="require('@/assets/icons/sidebars/404.svg')" alt="" />
    </div>
  </div>
  <div class="c-404-title">
    <span class="name">{{ $t('errorNotFound') }}</span>
    <span class="desc">{{ $t('errorNotFoundMessage') }}</span>
  </div>
</div>
